export default __webpack_public_path__ + "static/media/logo.f944bb8c.png";